<template>
  <Row class="h-100b nav-item-stock whitespace-nowrap" x="c" y="c">
    <img class="w-20 h-20 m-r-4 -m-t-2 stock-icon-pulse shrink-0" src="@/image/stock/menu-rwa.png" alt="">
    <span class="label text-nowrap shrink-0">{{ $t('stock.stockhub') }}</span>
  </Row>
</template>
<script setup>
</script>
<style lang="scss">
@use "sass:math";
@use "sass:map";
@import '@/sass/var/index.scss';
.nav-item-stock{
      position: relative;
      width: 104px;
      height: 32px !important;
      background:linear-gradient(37.66deg, #FFFFFF 4.83%, #02F1C6 27.79%, #2649EF 86.77%) no-repeat center center;
      background-size: cover;
      border-radius: 32px;
      color: $color-white !important;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: -10px;
        left: -20px;
        width: 16px;
        height: 51px;
        background: linear-gradient(90deg,
          rgba(128, 255, 232, 1) 0%,
          rgba(128, 255, 232, 1) 50%,
          rgba(128, 255, 232, 1) 100%);
        filter: blur(8px);
        transform: rotate(45deg);
        animation: shine 2s ease-in-out infinite;
        z-index: 0;
      }

      img, .label {
        position: relative;
        z-index: 1;
      }
    }

.stock-icon-pulse {
  animation: pulse 0.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.15);
  }
}

@keyframes shine {
  0% {
    left: -20px;
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    left: 120px;
    opacity: 0;
  }
}
</style>
